// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-linear-gradient[data-v-11c8649f]{background:linear-gradient(180deg,#162440,rgba(22,36,64,.6) 20%,rgba(22,36,64,.4) 46%,rgba(22,36,64,0) 66%)}@media screen and (min-width:768px){.custom-linear-gradient[data-v-11c8649f]{background:linear-gradient(90deg,#162440,#162440 20%,rgba(22,36,64,.9) 32%,rgba(22,36,64,0) 70%)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
